/**
 * File: useFloatingTimerController.ts
 * Path: apps/admin/src/shared/hooks/useFloatingTimerController.ts
 * Description: The floating timer's clock text, ticking once a second.
 */

import { useEffect, useState } from "react";
import { formatClock } from "../utils/timerUtils";

export const useFloatingTimerController = (startedAt: number) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);
  return { clock: formatClock(now - startedAt) };
};
